import { components } from "@apiSchema";
import { useData } from "@hooks/useData";
import { PermissionFields, PermissionLevelEnum, PermissionSection } from "@models/PermissionSection";
import Http from "@core/fetch";
import { ID } from "@models";
import { FPChainData, iBrandData } from "@models/Brands";

async function getBrands(chainId: ID): Promise<iBrandData> {
    const data: components["schemas"]["FPChainDataChainPermissionWrapper"] = await Http.get('get brand data', { chainId });
    const permissionLevel = PermissionSection.getPermissionLevel(data.permissionLevel);
    const hasData = data.hasData || false;

    if (permissionLevel === PermissionLevelEnum.None) {
        return { permissionLevel, hasData, data: FPChainData.fakeData };
    }

    return {
        permissionLevel,
        hasData,
        data: data.data ? { ...data.data, chainType: data.data.chainType as any } : new FPChainData(),
    };
}

export default function useBrands(chainId: ID) {
    return useData({
        ...new PermissionFields(),
        data: new FPChainData(),
    }, getBrands, chainId);
}